module.exports = __webpack_public_path__ + "img/header_christmas_600.4e274a2.png";